import { Grid } from "@mui/material";
import ParameterItem from "./ParameterItem";

export default function ParameterList({ params, data }) {
  return (
    <Grid item sm container spacing={2}>
      {params.map((item) => (
        <ParameterItem key={item.key} item={item} data={data} sx={{}} />
      ))}
    </Grid>
  );
}
